/**
 * Format creation date of acrticles to schema markup
 */
const dateForSchema = (date: string): string => {
  const formatedDate = new Date(date).toISOString().slice(0, 10);

  return formatedDate;
};

export default dateForSchema;
